import React, { Component } from "react";
import PatientFilter from "./Report.PatientsFilter";
import ListReport from "./Report.ListReport";
import DetailsReport from "./Report.DetailsReport";
import HomeCareReport from "./Report.HomeCare"
import CountReport from "./Report.CountReport"

class Patient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "Filter",
      data: null
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    if (this.state.mode === "Filter") {
      return (
        <PatientFilter
          onClick={this.handleClick}
          reportType={this.props.reportSubType}
        />
      );
    } else if (this.state.mode === "Next OP") {
      return (
        <ListReport data={this.state.data} onCloseClick={this.handleClick} />
      );
    }
    else if (this.state.mode === "Details") {
      return (
        <DetailsReport data={this.state.data} onCloseClick={this.handleClick} />
      );
    }
    else if (this.state.mode === "Home Care") {
      return (
        <HomeCareReport data={this.state.data} onCloseClick={this.handleClick} />
      );
    }
    else if (this.state.mode === "Count") {
      return (
        <CountReport data={this.state.data} onCloseClick={this.handleClick} />
      );
    }
  }

  handleClick(mode, data) {
    this.setState({ mode, data });
  }
}

export default Patient;
